module.exports = __webpack_public_path__ + "img/s2-3.68f47374.jpg";